module.exports = __webpack_public_path__ + "img/Filter_Line_16px_Icon.cef43d87.svg";